import { requestJira } from '@forge/bridge';

const rejectIfError = async (response: Response) => {
    if (response.status >= 300) {
        const json = await response.json();
        return Promise.reject(json);
    } else {
        return response;
    }
};

const rejectIfErrorAndExtractJson = async (response: Response) => {
    const json = await response.json();

    return response.status >= 300 ? Promise.reject(json) : json;
};

export const getJson = (url: string): Promise<any> =>
    requestJira(`/rest/api/3${url}`).then(response => rejectIfErrorAndExtractJson(response));

export const requestServiceDesk = <T>(url: string, fetchOptions?: RequestInit | undefined): Promise<T> =>
    requestJira(`/rest/servicedeskapi${url}`, fetchOptions).then(response => rejectIfErrorAndExtractJson(response));

export const parseClientError = (error: { errorMessages: string[]; errors: string[] }) => {
    return error.errorMessages?.length ?
            error.errorMessages.join('; ')
        :   Object.entries(error.errors)
                .map(([, errorMessage]) => errorMessage)
                .join(', ');
};

const sendJsonRequest = (url: string, body: any, method: string): Promise<any> =>
    requestJira(`/rest/api/3${url}`, {
        method: method,
        body: JSON.stringify(body),
        headers: { 'content-type': 'application/json' },
    }).then(response => rejectIfError(response));

export const postRequest = (url: string, body: any): Promise<any> => sendJsonRequest(url, body, 'POST');

export const putRequest = (url: string, body: any): Promise<any> => sendJsonRequest(url, body, 'PUT');

export const deleteRequest = (url: string, body: any): Promise<any> => sendJsonRequest(url, body, 'DELETE');
